import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';

export const InspectionUsageTableHeaders = ({
  t,
  onSort,
}: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={t('common:date')}
        thClassName="min-w-[147px]"
        sortable
        onSortClick={() => onSort?.('updatedAt')}
      />
      <TableHead
        text={`${t('common:licensePlateNumber')} & ${t('common:vin')}`}
        thClassName="min-w-[150px]"
        onSortClick={() => onSort?.('licensePlateAndVin')}
      />
      <TableHead
        text={t('common:referenceNumber_short')}
        thClassName="w-[135px]"
      />
      <TableHead text={t('common:client')} thClassName="min-w-[150px]" />
      <TableHead
        text={t('common:type')}
        thClassName="text-center min-w-0 w-0"
      />
      <TableHead
        text={t('common:status')}
        thClassName="!px-2.5 text-center w-[108px]"
      />
      <TableHead
        text={t('common:making')}
        thClassName="!px-2.5 text-center w-[157px]"
      />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
